// import React, { useEffect, useState } from 'react';
import { AppRouter } from 'routers/AppRouter';
// import { useQuery } from 'hooks/useQuery';
import { Provider } from 'react-redux';
import { store } from 'store';
import zhCN from 'antd/es/locale/zh_CN';
import { ConfigProvider } from 'antd';

export const App = () => (
  <Provider store={store}>
    <ConfigProvider locale={zhCN}>
      <AppRouter />
    </ConfigProvider>
  </Provider>
);
